import angular from 'angular';
import template from './webcam-blocked.html';
import './webcam-blocked.scss';
import chrome from './chrome/webcam-blocked-chrome';
import noChrome from './non-chrome/webcam-blocked-non-chrome';
class WebcamBlockedController {
    constructor(Browser) {
        this.Browser = Browser;
    }
    $onInit() {
        this.browser = this.Browser.getSystemInfo().browser;
    }
}
const webcamBlocked = {
    template,
    bindings: {},
    controller: WebcamBlockedController,
};
export default angular
    .module('doxy.videoChat.userMediaStatus.common.components.webcamBlocked', [
    chrome,
    noChrome,
])
    // webcam-blocked
    .component('webcamBlocked', webcamBlocked).name;
